import React from 'react';
import LoadingMask from '../../../../../CommonComponents/LoadingMask';
import { formatNumberLegacy } from '../../../../../CommonUtils/formatNumberLegacy';
import { AssetClass, Returns, Volatilities } from '../../types';
import { ColumnsContainer, Container, Header, Row, Value } from './styles';

export interface CapitalMarketAssumptionsTableProps {
  includedAssetClasses: AssetClass[];
  returns: Returns;
  volatilities: Volatilities;
}

export const LoadingCapitalMarketAssumptionsTable: React.FC = () => (
  <Container>
    <ColumnsContainer>
      <LoadingMask isDark height="350px" />
    </ColumnsContainer>
    <ColumnsContainer>
      <LoadingMask isDark height="350px" />
    </ColumnsContainer>
  </Container>
);

const renderTable = (assetClasses: AssetClass[], returns: Returns, volatilities: Volatilities) => (
  <ColumnsContainer>
    <Row>
      <Header>Asset Class</Header>
      <Header>Avg Return</Header>
      <Header>Volatility</Header>
    </Row>

    {assetClasses.map(({ id, customName }) => (
      <Row key={id}>
        <Value>{customName}</Value>
        <Value>
          {formatNumberLegacy(returns[id], {
            type: 'percent',
            minDecimalPlaces: 2,
            maxDecimalPlaces: 2,
          })}
        </Value>
        <Value>
          {formatNumberLegacy(volatilities[id], {
            type: 'percent',
            minDecimalPlaces: 2,
            maxDecimalPlaces: 2,
          })}
        </Value>
      </Row>
    ))}
  </ColumnsContainer>
);

export const CapitalMarketAssumptionsTable: React.FC<CapitalMarketAssumptionsTableProps> = ({
  includedAssetClasses,
  returns,
  volatilities,
}) => {
  const splitIndex =
    includedAssetClasses.length % 2 === 0
      ? includedAssetClasses.length / 2
      : includedAssetClasses.length / 2 + 1;

  return (
    <Container>
      {renderTable(includedAssetClasses.slice(0, splitIndex), returns, volatilities)}

      {renderTable(includedAssetClasses.slice(splitIndex), returns, volatilities)}
    </Container>
  );
};
